import { GlobalAxios } from "../axios/axios-config";
import {
  INewSendLimitDiary,
  ISendLimitDiary,
} from "../models/send-limit-diary";

const SEND_LIMIT_DIARY_ROUTE =
  process.env.REACT_APP_TICKETS + "/api/v1/SendLimitDiary";

export const createSendLimitDiary = (item: INewSendLimitDiary) => {
  return GlobalAxios.post(SEND_LIMIT_DIARY_ROUTE, item);
};

export const getSendLimitDiaryById = (id: string) => {
  return GlobalAxios.get<ISendLimitDiary>(SEND_LIMIT_DIARY_ROUTE + "/" + id);
};

export const updateSendLimitDiaryById = ({
  item,
  id,
}: {
  item: INewSendLimitDiary;
  id: string;
}) => {
  return GlobalAxios.put(SEND_LIMIT_DIARY_ROUTE + "/" + id, item);
};
